export default "__VITE_ASSET__d6ba79db__"